import React from 'react'
import {Typography, SxProps, Theme} from '@mui/material'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import Card from 'src/components-new/layout/Card'

interface ChartCardProps {
  title: string
  options: Highcharts.Options
  sx?: SxProps<Theme>
}

export default function ChartCard({title, options, sx}: ChartCardProps) {
  return (
    <Card sx={sx}>
      <Typography variant="h3" sx={{mb: 2}}>
        {title}
      </Typography>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Card>
  )
}
